import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../settings-action-id.constants';
import * as Actions from '../evidence-list.actions';

class EvidenceApplicableHeadOfficesGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.evidenceApplicableHeadOfficesGrid;
        this.filterComponent = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        this.icon = false;

        this.columns = [
            {title: 'Applicable Head Offices', mapper: 'name'},
            {title: 'Enabled', mapper: 'checkbox', identifier:this.identifier, statePath: this.statePath, style:{width:'35px'}},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);
        this.dataAction = this.fetchEvidenceApplicableHeadOfficesGrid;
        this.buttons = [
            {
                class: 'btnGridAction',
                label: 'Sites',
                callback: this.onSelect,
                filter: item => item.applicable,
            },
        ];
        this.unsubscribeGridCheckboxChange = this.$scope.$on('grid-checkbox-change', this.onCheckboxChange.bind(this));

        this.init();
    }

    onCheckboxChange (event, hof_uuid, isSelected, path) {
        if (path === this.statePath) {
            const item = event.currentScope.$ctrl.items.filter( item => item.uuid === hof_uuid)[0];
            if (item)
                item.applicable = isSelected;
        }
    }

    $onDestroy() {
        this.destroy();
        if (this.unsubscribeGridCheckboxChange) {
            this.unsubscribeGridCheckboxChange();
        }
    }
}

EvidenceApplicableHeadOfficesGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const evidenceApplicableHeadOfficesGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
    },
    controller: EvidenceApplicableHeadOfficesGridController,
    ...gridTpl
}
